import * as React from "react";

const LtMeter = ({ color = "black", height = 24, width = 24 }) => (
    <svg
        width={width}
        height={height}
        viewBox="7200 14300 500 500"

        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7212 14708 c-8 -8 -12 -67 -12 -198 0 -131 4 -190 12 -198 8 -8 68 -12 203 -12 135 0 195 4 203 12 8 8 12 67 12 198 0 131 -4 190 -12 198 -17 17 -389 17 -406 0z m383 -198 l0 -185 -180 0 -180 0 -3 175 c-1 96 0 180 3 187 3 11 43 13 182 11 l178 -3 0 -185z"
            fill={color}
        />
        <path
            d="M7250 14560 l0 -110 165 0 165 0 0 110 0 110 -165 0 -165 0 0 -110z m300 0 l0 -90 -34 0 c-25 0 -38 6 -50 25 -9 14 -25 25 -36 25 -12 0 -25 10 -32 25 -15 33 -32 32 -25 -2 8 -41 -18 -73 -59 -73 l-34 0 0 90 0 90 135 0 135 0 0 -90z m-110 -81 c0 -5 -11 -9 -25 -9 -26 0 -34 15 -12 23 16 5 37 -3 37 -14z"
            fill={color}
        />
        <path
            d="M7333 14600 c-18 -11 -33 -24 -33 -30 0 -15 11 -13 55 10 43 23 92 20 132 -6 26 -16 43 -18 43 -4 0 22 -65 50 -115 50 -32 0 -62 -7 -82 -20z"
            fill={color}
        />
        <path
            d="M7261 14406 c-19 -22 -4 -56 23 -56 32 0 53 26 39 48 -14 23 -47 27 -62 8z"
            fill={color}
        />
        <path
            d="M7350 14386 c0 -43 5 -45 118 -37 7 1 12 15 12 36 l0 35 -65 0 -65 0 0 -34z m100 -1 c0 -10 -11 -15 -35 -15 -24 0 -35 5 -35 15 0 10 11 15 35 15 24 0 35 -5 35 -15z"
            fill={color}
        />
        <path
            d="M7511 14406 c-19 -22 -4 -56 23 -56 32 0 53 26 39 48 -14 23 -47 27 -62 8z"
            fill={color}
        />
    </svg>
);

export default LtMeter;
